<template>
<div>
  <div class="section-header">
    <h1>Subscription Plans</h1>
    <button class="align-center" @click="newOfferingModal=true"><h-icon>add</h-icon>Create</button>
 </div>
 <div class="card-rows">
    <offering 
       v-for="offering in offerings"
       :key="offering.id"
       :habitPrograms="habitPrograms"
       :pulseSurveys="pulseSurveys"
       :company="company"
       :coaches="coaches"
       :courses="courses"
       :offering="offering"
       :subDomains="subDomains"

    />
 </div>
  <modal v-if="newOfferingModal">
    <div class="card card--white">
      <div class="card--container">
        <button style="float: right" @click="newOfferingModal=false">
          <h-icon>close</h-icon>
        </button>
        <offering-card :habitPrograms="habitPrograms"
                   :pulseSurveys="pulseSurveys"
                   :company="company"
                   :coaches="coaches"
                   :courses="courses"
                   :offering="newOffering"
                   :subDomains="subDomains"
                   @saved="updateOfferings"
                  />
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import offering from "./offering";
import offeringCard from "./offeringsCard";
import store from "@/services/api/store";
import modal from "@/components/modal";
const CLIENT_OFFERINGS_STORE = "OwnerClientOfferings";
const HABIT_PROGRAM_STORE = "CoachHabitPrograms";
const COACH_STORE = "OwnerCoaches";
const PULSE_SURVEY_STORE = "CoachPulseSurveys";
const COMPANY_STORE = "OwnerCompany";
const COURSES_STORE = "CoachCourses";
const SUB_DOMAINS = "CoachSubDomains";

import _ from "lodash";

export default {
  components: { offering, modal, offeringCard },
  data() {
    return {
      habitPrograms: [],
      pulseSurveys: [],
      company: {},
      coaches: [],
      courses: [],
      offerings: [],
      newOffering: { courses: [] },
      subDomains: [],
      newOfferingModal: false
    }
  },
  created() {
    store
      .findAll(CLIENT_OFFERINGS_STORE, { default: true, limit: 100 }, { force: true })
      .then(r => {
        this.offerings = r || [];
      });

    store
      .findAll(SUB_DOMAINS, {}, { force: true })
      .then(r => {
        this.subDomains = r;
      });

    store.findAll(HABIT_PROGRAM_STORE, { limit: 100 }).then(r => {
      this.habitPrograms = _.orderBy(r, ["name"]);
    });

    store.findAll(PULSE_SURVEY_STORE, { limit: 100 }).then(r => {
      this.pulseSurveys = _.orderBy(r, ["name"]);
    });


    store.findAll(COMPANY_STORE, { limit: 100 }, { force: true }).then(r => {
      this.company = r[0] || {};
      this.offering.company = this.company.id;
    });

    store.findAll(COACH_STORE, { limit: 100 }).then(coaches => {
      this.coaches = coaches;
      if (coaches.length === 1) {
        this.newOffering.coach = coaches[0].id;
        this.newOffering.coach_profile = coaches[0].coach_profile;
      }
    });

    store.findAll(COURSES_STORE, { limit: 100 }).then(r => {
      this.courses = _.orderBy(r, ["title"]);
    });
  },
  methods: {
    updateOfferings(offering) {
      this.newOfferingModal = false;
      this.offerings = [offering, ...this.offerings];
      this.newOffering = { 
        courses: [],
      };

      if (this.coaches.length === 1) {
        this.newOffering.coach = this.coaches[0].id;
        this.newOffering.coach_profile = this.coaches[0].coach_profile;
      }
    }
  }

}
</script>

<style>

</style>
